var RouteViewKeys = /** @class */ (function () {
    function RouteViewKeys() {
    }
    RouteViewKeys.SEARCH = '';
    RouteViewKeys.DETAIL = 'course-detail';
    RouteViewKeys.LOGIN = 'course-login';
    RouteViewKeys.SHOPPING_CART = 'shopping-cart';
    RouteViewKeys.SUMMARY = 'summary';
    RouteViewKeys.SUMMARY_CO_BRANDING = 'summary-co-branding';
    RouteViewKeys.CLASSIFICATION = 'course-classification'; // inactive
    RouteViewKeys.CONFIRMATION = 'booking-confirmation';
    RouteViewKeys.CONFIRMATION_CO_BRANDING = 'booking-confirmation-co-branding';
    RouteViewKeys.HCO_CODE = 'hco-code'; // inactive
    RouteViewKeys.VERIFICATION = 'verification';
    RouteViewKeys.INTAKE_REGISTRATION = 'intake-registration';
    RouteViewKeys.DAAD_REGISTRATION = 'daad-registration';
    RouteViewKeys.DFH_REGISTRATION = 'dfh-registration';
    RouteViewKeys.BOOK_NEXT_COURSE = 'next-intake-course';
    RouteViewKeys.PENDING = 'pending';
    return RouteViewKeys;
}());
export { RouteViewKeys };
